export default __webpack_public_path__ + "static/media/store.604e9b04.svg";